export const shareLibraryUrl = '/share-library';

export enum ShareLibraryAssetTab {
  All = 'all',
  Recordings = 'recordings',
  Uploads = 'uploads',
}
